<div class="content content-fixed content-auth-alt">
    <div class="container d-flex justify-content-center ht-100p">
        <div class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center">
            <!-- <div class="wd-80p wd-sm-300 mg-b-15">
                <img src="/assets/img/logo.jpg" class="img-fluid" alt="">
            </div> -->
            <h4 class="tx-20 tx-sm-24">Recuperar contraseña</h4>
            <p class="tx-color-03 mg-b-30 tx-center">
                Ingrese su dirección de correo electrónico y le enviaremos un enlace para restablecer su contraseña.
            </p>
            <div class="wd-100p d-flex flex-column flex-sm-row mb-3">
                <input type="email" required class="form-control wd-sm-250 flex-fill" placeholder="Correo electrónico" [(ngModel)]="email">
            </div>
            <div class="wd-100p d-flex flex-column flex-sm-row mg-b-40">
                <button class="btn btn-outline-secondary  mg-t-10 mg-sm-t-0" routerLink="/login">Cancelar</button>
                <button class="btn btn-brand-02 mg-sm-l-10 mg-t-10 mg-sm-t-0" [disabled]="!email" (click)="passwordRecovery()">Restablecer contraseña</button>    
            </div>
            
        </div>
    </div><!-- container -->
</div>